<div class="min-w-0 px-6 xl:px-[120px] pt-20 pb-10 bg-white">
    <div class="flex min-w-0 flex-col items-stretch justify-center gap-6 md:flex-row md:gap-8">
        <!-- Left Sidebar: Filters -->
        <vsf-product-list-controls
            class="hidden w-full shrink-0 md:block md:w-[240px] lg:w-[260px]"
            [facetValues]="facetValues"
            [activeFacetValueIds]="activeFacetValueIds$ | async"
            [totalResults]="unfilteredTotalItems"></vsf-product-list-controls>

        <!-- Right: Products -->
        <div class="flex-1 min-w-0 flex flex-col gap-6">
            <!-- Collection Title -->
            <ng-container *ngIf="collection$ | async as collection">
                <h2 class="text-body text-2xl font-semibold">
                    {{ collection.name }}
                </h2>

                <!-- Sub-collections -->
                <ng-container *ngIf="collection.children?.length">
                    <div class="grid grid-cols-2 gap-3 pb-6 border-b border-gray-200 mb-4 sm:gap-4 md:grid-cols-3 lg:grid-cols-4">
                        <vsf-collection-card *ngFor="let child of collection.children"
                                             [collection]="child">
                        </vsf-collection-card>
                    </div>
                </ng-container>
            </ng-container>

            <!-- Search Term -->
            <h2 class="text-body text-2xl font-semibold" *ngIf="searchTerm$ | async as term">
                Results for <span class="font-bold">"{{ term }}"</span>
            </h2>

            <!-- Items Count + Sort -->
            <div class="flex items-center justify-between" *ngIf="(products$ | async)?.length > 0">
                <p class="text-body text-base" *ngIf="totalResults$ | async as total">
                    {{ total }} items
                </p>
                <div class="flex items-center gap-2">
                    <span class="text-body text-lg font-semibold whitespace-nowrap">Sort By:</span>
                    <select class="text-body text-base border-none bg-transparent focus:ring-0 focus:outline-none cursor-pointer py-0 pl-0 pr-6"
                            [ngModel]="activeSortValue"
                            (ngModelChange)="onSortChange($event)">
                        <option value="name-ASC">A to Z &#8593;</option>
                        <option value="name-DESC">Z to A &#8595;</option>
                        <option value="price-ASC">Price &#8593;</option>
                        <option value="price-DESC">Price &#8595;</option>
                    </select>
                </div>
            </div>

            <!-- Mobile Filter Toggle -->
            <div class="md:hidden">
                <vsf-product-list-controls
                    [facetValues]="facetValues"
                    [activeFacetValueIds]="activeFacetValueIds$ | async"
                    [totalResults]="unfilteredTotalItems"></vsf-product-list-controls>
            </div>

            <!-- Product Grid -->
            <ng-container *ngIf="(totalResults$ | async) !== null; else placeholders">
                <div *ngIf="(products$ | async)?.length > 0; else noProducts" class="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5">
                    <vsf-product-card *ngFor="let product of products$ | async; trackBy: trackByProductId"
                                      [product]="product"></vsf-product-card>
                </div>
                <ng-template #noProducts>
                    <div class="flex flex-col items-center justify-center py-20 text-center">
                        <svg class="w-16 h-16 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                        </svg>
                        <h3 class="text-heading text-xl font-semibold mb-2">{{ 'product.noProducts' | translate }}</h3>
                        <p class="text-disabled text-base">{{ 'product.tryAdjusting' | translate }}</p>
                    </div>
                </ng-template>
            </ng-container>
            <ng-template #placeholders>
                <div class="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5">
                    <div *ngFor="let i of [1,2,3,4,5,6]" class="flex flex-col gap-2 animate-pulse">
                        <div class="bg-gray-200 rounded aspect-[4/5]"></div>
                        <div class="h-4 bg-gray-200 rounded w-1/3"></div>
                        <div class="h-5 bg-gray-200 rounded w-2/3"></div>
                        <div class="h-5 bg-gray-200 rounded w-1/4"></div>
                    </div>
                </div>
            </ng-template>

            <!-- Load More -->
            <div class="text-center mt-8" *ngIf="displayLoadMore$ | async">
                <button class="bg-primary text-white font-medium px-8 py-3 rounded-lg hover:bg-primary-600 transition-colors"
                        (click)="loadMore()"
                        [disabled]="loading$ | async">
                    Load more
                    <span *ngIf="loading$ | async" class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin ml-2"></span>
                </button>
            </div>
        </div>
    </div>
</div>
